import React, { useState } from "react";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import ServiceCategories from "../components/ServiceCategories";
import About from "../components/About";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div>
      <Navigation />
      <Hero />
      <ServiceCategories />
      <About />
      <Services />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
